// extracted by mini-css-extract-plugin
export default {"total":"SearchResult_total_ba9a6","totalValue":"SearchResult_totalValue_e3a8e","spinner":"SearchResult_spinner_bbada","headerCellText":"SearchResult_headerCellText_e6009"};